import './styles.scss'

interface BasicCardProps {
  title: string
  assistences?: string[]
}

function AssistenceInfoCard({ title, assistences = [] }: BasicCardProps) {
  return (
    <div className="container-AssistenceInfoCard cardAnimated">
      <div className="AssistenceInfoCard-title">
        <h2>{title}</h2>
      </div>
      <div className="AssistenceInfoCard-assistences">
        <ul>
          {assistences.length > 0 ? (
            assistences.map((assistence: string) => {
              const showMarker = !(
                assistence === 'Recebeu recentemente' ||
                assistence === 'Não recebeu esse auxílio recentemente' ||
                assistence === 'Não tem informação'
              )

              return (
                <li className={showMarker ? 'marked' : ''} key={assistence}>
                  {assistence}
                </li>
              )
            })
          ) : (
            <li>Não tem informação</li>
          )}
        </ul>
      </div>
    </div>
  )
}

export default AssistenceInfoCard
